import React, { useEffect, useState } from "react";
import "./ContactPage.css";
import Header from "../components/Header";
import Footer from "../components/Footer";
import SendIcon from "@material-ui/icons/Send";
import { useHistory } from "react-router-dom";
import { db } from "../config/firebase";
import firebase from "firebase";

const ContactPage = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [number, setNumber] = useState("");
  const [message, setMessage] = useState("");
  const [heading, setHeading] = useState("");

  let head = "Tell me about your next big plan..!";
  let i = 0;

  const history = useHistory();

  useEffect(() => {
    document.title = "Ashwin's Portfolio - Contact";
    setInterval(() => {
      let dummy = heading;
      if (head.length > heading.length) {
        setHeading((prevVal) => prevVal + head.charAt(i));
        i++;
      }
    }, 100);
    return () => {};
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (name !== "" && email !== "" && message !== "") {
      db.collection("ashwin-contact-form")
        .add({
          name,
          email,
          number,
          message,
          timestamp: firebase.firestore.FieldValue.serverTimestamp(),
        })
        .then(() => {
          setName("");
          setEmail("");
          setNumber("");
          setMessage("");
          history.push("/");
        })
        .catch((error) => {
          alert(error.message);
        });
    } else {
      alert(
        "One or more fields are not filled. Fill all the fields before clicking on send button"
      );
    }
  };

  return (
    <div className="contact">
      <Header />
      <div className="contact-body">
        <h3>{heading}</h3>
        <div className="form">
          <label>Name</label>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <label>E-mail</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <label>Number</label>
          <input
            type="number"
            value={number}
            onChange={(e) => setNumber(e.target.value)}
          />
          <label>Your message</label>
          <textarea
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            rows={8}
          />
          <button onClick={handleSubmit}>
            Send <SendIcon />
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ContactPage;
